export default __webpack_public_path__ + "static/media/tag-blue-xl.dfc7c61c.svg";